const _ = "record_y2Biw", t = "record__title_u1n4b", r = "record__content_iauBc", c = "record__status_hQyto", o = "record__status__chip_TDGeg", e = {
  record: _,
  record__title: t,
  record__content: r,
  record__status: c,
  record__status__chip: o
};
export {
  e as default,
  _ as record,
  r as record__content,
  c as record__status,
  o as record__status__chip,
  t as record__title
};
//# sourceMappingURL=orderRecord.module.scss.js.map
